import { render } from "./ScrollTopButton.vue?vue&type=template&id=3bb0f471&scoped=true"
import script from "./ScrollTopButton.vue?vue&type=script&lang=js"
export * from "./ScrollTopButton.vue?vue&type=script&lang=js"

import "./ScrollTopButton.vue?vue&type=style&index=0&id=3bb0f471&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bb0f471"]])

export default __exports__